import VueAnalytics from 'vue-analytics'

import 'normalize.css'
// Todo: set global scss: https://vueschool.io/articles/vuejs-tutorials/globally-load-sass-into-your-vue-js-applications/

import Vue from 'vue'
import App from './App.vue'

import router from './router'

import store from './store'

import './registerServiceWorker'

Vue.use(VueAnalytics, {
  id: 'UA-138262147-1'
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
